type BadgeVariant =
  | "default"
  | "secondary"
  | "success"
  | "warning"
  | "destructive"
  | "outline";

const STATUS_VARIANTS: Record<string, BadgeVariant> = {
  enrolled: "success",
  active: "success",
  suspended: "warning",
  revoked: "destructive",
  replaced: "secondary",
};

export function gatewayStatusVariant(status: string): BadgeVariant {
  return STATUS_VARIANTS[status] ?? "outline";
}

const CREDENTIAL_EVENT_LABELS: Record<string, string> = {
  enroll: "Enrolled",
  rotate: "Key rotated",
  revoke: "Revoked",
  replace: "Replaced",
};

export function credentialEventLabel(
  eventType: string | null | undefined,
): string {
  if (!eventType) return "—";
  return CREDENTIAL_EVENT_LABELS[eventType] ?? eventType;
}

export function titleCaseStatus(status: string): string {
  return status.length ? status[0].toUpperCase() + status.slice(1) : status;
}

export function sortedStatusCounts(
  byStatus: { [key: string]: number } | undefined,
): [string, number][] {
  if (!byStatus) return [];
  return Object.entries(byStatus).sort((a, b) => a[0].localeCompare(b[0]));
}
